export enum PromoCodeStatus {
  Active = 20,
  Claimed = 15, // Promo code has been entered somewhere, but the payment has not been made yet
  Used = 10,
  Revoked = -30,
  Expired = -20, // Schedule a batch process for every day, to update promo code status
}
